"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { wrapper, stepWrapper, stepIndicatorWrapper, stepHeader, stepContent, stepIndicator } from './styles.js';
import { IconCheck } from '../icons/ui_control/IconCheck.web.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { renderComponentOrElement } from '../utils/helpers/component.js';

var _excluded = ["orientation", "align", "steps", "wrapperClassName", "color", "transparent", "onStepIndicatorClick"];
var Stepper = function Stepper(_ref) {
  var _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === undefined ? 'vertical' : _ref$orientation,
    align = _ref.align,
    _ref$steps = _ref.steps,
    steps = _ref$steps === undefined ? [] : _ref$steps,
    wrapperClassName = _ref.wrapperClassName,
    colorProp = _ref.color,
    _ref$transparent = _ref.transparent,
    transparent = _ref$transparent === undefined ? false : _ref$transparent,
    onStepIndicatorClick = _ref.onStepIndicatorClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var stepperTheme = theme.stepper.web;
  var color = colorProp ? colorProp : stepperTheme.color;
  return /*#__PURE__*/React.createElement(wrapper, _extends({
    "data-testid": "elemental-Stepper",
    className: wrapperClassName,
    $layout: orientation
  }, props), steps.map(function (step, index) {
    var stepHasIcon = Boolean(step.icon);
    return /*#__PURE__*/React.createElement(stepWrapper, _extends({
      "data-testid": "elemental-Stepper-".concat(step.id),
      key: step.id,
      className: step.stepClassName,
      $valid: step.valid,
      $layout: orientation,
      $numSteps: steps.length,
      $hasIcon: stepHasIcon,
      $color: color,
      theme: theme,
      $align: align || stepperTheme.align,
      $transparent: transparent
    }, step.stepProps), /*#__PURE__*/React.createElement(stepIndicatorWrapper, {
      $layout: orientation,
      $align: (align || stepperTheme.align) === 'center' ? 'center' : 'start'
    }, /*#__PURE__*/React.createElement(StepIndicator, {
      step: step,
      orientation: orientation,
      color: color,
      theme: theme,
      transparent: transparent,
      stepNumber: index + 1,
      onStepIndicatorClick: onStepIndicatorClick
    })), step.header && /*#__PURE__*/React.createElement(stepHeader, {
      $inactive: step.inactive,
      $layout: orientation,
      $transparent: transparent,
      theme: theme,
      style: {
        textAlign: orientation === 'horizontal' ? align || stepperTheme.align : undefined
      }
    }, step.header), orientation === 'vertical' && /*#__PURE__*/React.createElement(stepContent, null, step.content), orientation === 'horizontal' && !step.inactive && /*#__PURE__*/React.createElement(stepContent, {
      $width: "".concat(steps.length * 100, "%"),
      $left: "-".concat(index * 100, "%")
    }, step.content));
  }));
};
var StepIndicator = function StepIndicator(props) {
  var step = props.step,
    color = props.color,
    orientation = props.orientation,
    stepNumber = props.stepNumber,
    transparent = props.transparent,
    theme = props.theme,
    onStepIndicatorClick = props.onStepIndicatorClick;
  var stepIcon = step.icon;
  var hasIcon = !!stepIcon;
  var inactiveContent = hasIcon ? renderComponentOrElement(stepIcon, {}, false) : stepNumber;
  var indicatorContent = step.valid ? /*#__PURE__*/React.createElement(IconCheck, {
    color: transparent ? theme.stepper.web.transparent.color : color,
    size: 24
  }) : inactiveContent;
  if (onStepIndicatorClick) {
    return /*#__PURE__*/React.createElement(stepIndicator, {
      $layout: orientation,
      $valid: step.valid,
      $inactive: step.inactive,
      $color: color,
      theme: theme,
      $hasIcon: hasIcon,
      $transparent: transparent,
      tabIndex: 0,
      "aria-label": step.ariaLabel || (/* istanbul ignore next */
      typeof step.header === 'string' ? step.header : undefined),
      onClick: function onClick() {
        return onStepIndicatorClick(step);
      },
      disabled: !step.valid
    }, indicatorContent);
  }
  return /*#__PURE__*/React.createElement(stepIndicator, {
    as: "span",
    $layout: orientation,
    $valid: step.valid,
    $inactive: step.inactive,
    $hasIcon: hasIcon,
    $color: color,
    $transparent: transparent,
    theme: theme
  }, indicatorContent);
};

export { Stepper };
